import React from 'react';
import { Lock, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { NO_ACCESS_ASSIGNED } from '../services/api';

/**
 * Signed in, known to FinOps, active -- and granted nothing.
 *
 * Deliberately all there is: who they are and a way out. No navigation, no
 * application shell, and no call to any API but /api/auth/me (made by
 * AuthContext) and logout, every one of which the backend would refuse them
 * anyway. Rendered in place of the application at any path, so there is no
 * redirect to loop on; it goes away by itself once an administrator grants a
 * permission and the next navigation or refresh re-reads /api/auth/me.
 */
export default function NoAccess() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4" data-testid="no-access-page">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-lg p-8 shadow-sm text-center">
        <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-5">
          <Lock size={20} className="text-amber-700" />
        </div>
        <h1 className="text-xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Chivo, sans-serif' }}>
          No FinOps access assigned
        </h1>
        <p className="text-sm text-slate-600 mb-6" data-testid="no-access-message">{NO_ACCESS_ASSIGNED}</p>
        <div className="border-t border-slate-100 pt-4 mb-6">
          <p className="text-sm font-medium text-slate-900" data-testid="no-access-name">{user?.full_name}</p>
          <p className="text-xs text-slate-500" data-testid="no-access-email">{user?.email}</p>
        </div>
        <button
          onClick={logout}
          className="inline-flex items-center gap-2 px-4 py-2 bg-indigo-900 text-white text-sm font-medium rounded-md hover:bg-indigo-800 transition-colors"
          data-testid="no-access-logout"
        >
          <LogOut size={15} />
          Sign out
        </button>
      </div>
    </div>
  );
}
